import React, { SetStateAction, useState } from 'react';
import logo from '../assets/images/white-logo.png';
import LanguageDialog from './LanguageDialog';

interface HeaderProps {
    selectedLanguage: 'en' | 'es' | 'ru';
    setSelectedLanguage: React.Dispatch<SetStateAction<'en' | 'es' | 'ru'>>;
}

const Header = ({ selectedLanguage, setSelectedLanguage }: HeaderProps) => {
    const [isLanguageDialogOpen, setIsLanguageDialogOpen] = useState<boolean>(false);

    return (
        <>
            <nav className="navbar bg-body-tertiary p-0">
                <div className="container-fluid d-flex justify-center py-2 header">
                    <div className="flex-grow-1 flex-shrink-1"></div>
                    <div className="flex-grow-1 flex-shrink-1 text-center">
                        <div className="d-flex justify-content-center">
                            <img
                                style={{ height: '4vh' }}
                                src={logo}
                                alt="Niagara Bottling Logo"
                                className="logo"
                            />
                            {process.env.REACT_APP_IS_DEV === 'true' ? (
                                <div
                                    style={{
                                        transform: 'rotate(-45deg)',
                                        marginLeft: '5px'
                                    }}>
                                    Dev!
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div
                        onClick={() => {
                            setIsLanguageDialogOpen(true);
                        }}
                        className="flex-grow-1 flex-shrink-1 d-flex justify-content-end language-buttons">
                        <div className={`border border-white p-1 rounded`}>Language</div>
                    </div>
                </div>
            </nav>
            <LanguageDialog
                isLanguageDialogOpen={isLanguageDialogOpen}
                setIsLanguageDialogOpen={setIsLanguageDialogOpen}
                selectedLanguage={selectedLanguage}
                setSelectedLanguage={setSelectedLanguage}
            />
        </>
    );
};

export default Header;
